import { Component, OnInit } from '@angular/core';
import { ValidateId } from "../id-validator";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { TermsOfUseComponent } from "../terms-of-use/terms-of-use.component";
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  showContactUs: boolean = true;
  modalRef

  constructor(private router: Router,
        private modalService: NgbModal
  ) {
    router.events
			.filter(event => event instanceof NavigationEnd)
			.subscribe((event:any) => {
  
        let path = event.url.split("/");
        
        this.showContactUs = (path[path.length-1] !== "end");

			});
  }

  ngOnInit() {
  }
  

 

  openHelpDialog() {
    this.modalRef = this.modalService.open(HelpDialogComponent);
   
  }

 

 openTermOfUseDialog(){
    this.modalRef = this.modalService.open(TermsOfUseComponent,{ size: 'lg' });
 }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts